module.exports = __webpack_public_path__ + "img/Dantam Fashion 15.94fb2117.jpg";